import { render, staticRenderFns } from "./ModattaToast.vue?vue&type=template&id=8b7174b2&scoped=true"
import script from "./ModattaToast.vue?vue&type=script&lang=js"
export * from "./ModattaToast.vue?vue&type=script&lang=js"
import style0 from "./ModattaToast.vue?vue&type=style&index=0&id=8b7174b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7174b2",
  null
  
)

export default component.exports